import axios from 'axios';
import { UserLoginModel } from '../types';
import './axios-interceptor';

export default {
  async doLogin(user: UserLoginModel) {
    return await axios.post(`auth/login`, {
      mobileNo: user.mobileNo,
      password: user.password,
    });
  },

  async forgotPassword(mobileNo: string, email: string) {
    return await axios.post(`auth/forgetPassword`, {
      mobileNo: mobileNo,
      email: email,
    });
  },

  async validate() {
    return await axios.post(`auth/validate`);
  },

  async changePassword(oldPassword: string, newPassword: string) {
    return await axios.put(`auth/changePassword`, {
      oldPassword: oldPassword,
      newPassword: newPassword,
    });
  },
};
